import { render } from "./TaskAttachments.vue?vue&type=template&id=46955370&scoped=true"
import script from "./TaskAttachments.vue?vue&type=script&lang=js"
export * from "./TaskAttachments.vue?vue&type=script&lang=js"

import "./TaskAttachments.vue?vue&type=style&index=0&id=46955370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46955370"]])

export default __exports__